module.exports = __webpack_public_path__ + "img/partner16.46500c52.png";